
<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onRead="handleRead" @onGoBack="handleGoBack" :record="record" :is="currentComponet"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/a-trade/custom_reminder/template/table/List'
import Edit from '@/views/a-trade/custom_reminder/template/table/Edit'
import Read from '@/views/a-trade/custom_reminder/template/table/Read'

export default {
  name: 'ContractInformation',
  components: {
    AInput,
    ATextarea,
    List,
    Edit,
    Read
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  created () {

  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      console.log(record)
    },
    handleRead (record) {
      this.record = record || ''
      this.currentComponet = 'Read'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
